import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { nativeJSComm, nativeJSMapper } from '../util/WebFns'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { sendEventApi } from './sendEvent'

export const mimeTypes = new Map([
  ['application/vnd.ms-excel', '.xls'],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.xlsx'],
  ['application/pdf', '.pdf'],
  ['text/csv', '.csv'],
  ['text/plain', '.txt'],
  ['application/text', '.txt'],
  ['application/octet-stream', '.csv'],
])

const contentType = 'application/pdf'
export const downloadWeb = (response?: any, callback?: any) => {
  let blob = new Blob()
  let fileName = `{tileInfo?.[RootStore?.consents?.appType]}_${response.rrn}_RECEIPT`
  blob = b64toBlob(response?.response)
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = `${fileName}${mimeTypes.get(contentType)}`
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
  callback('File downloaded successfully.')
}

export const sendDataForDownload = (data?: any, onDownloadSuccess?: any, onDownloadFailed?: any) => {
  const byteData = data?.response
  let fileName = `${tileInfo?.[RootStore?.consents?.appType]}_${data.rrn}_RECEIPT`
  let req = {
    contentType,
    data: byteData,
    dataType: 'base64',
    fileName,
  }
  console.log('req download data', req)
  nativeJSComm(nativeJSMapper.downloadReceipt, onDownloadSuccess, onDownloadFailed, req)
}

const responseParser = (response: any, rrn: string, token, request) => {
  // let json: any = null
  // try {
  //   json = JSON.parse(new TextDecoder().decode(response?.data as ArrayBuffer))
  // } catch (error) {
  //   console.log('failed to parse arraybuffer data', error)
  // }
  // if (json?.response) {
  //   const data = { ...json, rrn: rrn }
  //   return data
  // } else if (json?.errorMsg) {
  //   const message = {
  //     message: json.errorMsg,
  //     rrn: rrn,
  //     code: json.errorCode,
  //   }
  //   throw message
  // } else
  if (response?.data?.response) {
    const data = { ...response?.data, rrn: rrn }
    console.log('parsed data', data)
    sendEventApi(token, request, { status: 'SUCCESS' })
    return data
  } else {
    const message = {
      message: response.data.errorMsg,
      rrn: rrn,
      code: response.data.errorCode,
    }
    throw message
  }
}

export const downloadReceipt = (tokens: any, txnId: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.getReceipt,
    method: 'POST',
    config: config,
    body: { rrn: txnId },
    // responseType: 'arraybuffer',
  }
  sendEventApi(tokens, request, { status: 'INITIATED' })
  return executeRequest(request)
    .then((response) => {
      console.log('print receipt api response ==> ', response)
      return responseParser(response, txnId, tokens, request)
    })
    .catch((err) => {
      sendEventApi(tokens, request, { status: 'FAILED',  errorDescription: err })
      return responseParser(err, txnId, tokens, request)
    })
}

export const b64toBlob = (b64Data: string, sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

const tileInfo = {
  '0': 'AEPS',
  '1': 'DMT',
  '2': 'REFUND',
}
